<template>
  <v-card>
    <v-card-title class="headline"> Update Password </v-card-title>
    <v-card-text>
      <v-form ref="form" @submit.prevent="handleUpdatePassword" v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="password"
                label="Password"
                name="password"
                type="password"
                :rules="[rules.required, rules.min, passwordConfirmRule]"
                value
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="confirmPassword"
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                value
              />
            </v-col>

            <v-btn
              type="submit"
              :disabled="!valid"
              color="#FC4A46"
              class="register"
              >Submit</v-btn
            >
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-snackbar v-model="passwordChanged" dark color="#0274b3" timeout="-1">
      You’ve successfully reset your password. Please log back in.

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="passwordChanged = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      valid: false,
      dialog: false,
      password: '',
      confirmPassword: '',
      passwordChanged: false,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
      },
    };
  },
  methods: {
    updatedPassword() {
      this.$store.dispatch('HANDLE_RESET_PASSWORD', {
        code: this.$route.query.code, // code contained in the reset link of step 3.
        password: this.password,
        passwordConfirmation: this.confirmPassword,
      });
    },

    passwordChangedMessage() {
      this.passwordChanged = true;
    },

    handleUpdatePassword() {
      this.updatedPassword();
      this.passwordChangedMessage();
    },
  },
  computed: {
    passwordConfirmRule() {
      return this.password === this.confirmPassword || 'Password must match';
    },
  },
};
</script>
